import { createSelector } from 'reselect';

export const getComponentState = state => state.adminApparelItems;

export const getApparelItems = createSelector(
    getComponentState,
    (state) => state.apparelItems
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getIsRejecting = createSelector(
    getComponentState,
    (state) => state.isRejecting
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getApparelItem = createSelector(
    getComponentState,
    (state) => state.apparelItem
);
export const getTileImage = createSelector(
    getComponentState,
    (state) => state.tileImage
);
export const getImage1 = createSelector(
    getComponentState,
    (state) => state.image1
);
export const getImage2 = createSelector(
    getComponentState,
    (state) => state.image2
);
export const getImage3 = createSelector(
    getComponentState,
    (state) => state.image3
);
export const getDepartments = createSelector(
    getComponentState,
    (state) => state.departments
);
export const getIsDeleting = createSelector(
    getComponentState,
    (state) => state.isDeleting
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getIsUploading = createSelector(
    getComponentState,
    (state) => state.isUploading
);
export const getUploadFile = createSelector(
    getComponentState,
    (state) => state.uploadFile
);
export const getAllDepartments = createSelector(
    getComponentState,
    (state) => state.allDepartments
);
export const getSizeCharts = createSelector(
    getComponentState,
    (state) => state.sizeCharts
);
export const getShowUtp = createSelector(
    getComponentState,
    (state) => state.showUtp
);
export const getShowUth = createSelector(
    getComponentState,
    (state) => state.showUth
);